module.exports = __webpack_public_path__ + "static/img/sou-n-m@2x.186122c7.png";